import { v4 as uuidv4 } from 'uuid';
import type { FileUIPart } from 'ai';
import type { GroupId, UserId, ViewModelId } from 'balus-common';
import { StoragePath } from 'balus-common';
import { StorageRefBuilder } from '@framework/firebase/storage';

// 1メッセージあたりに添付できる画像の最大数（バックエンドの検証と揃える）
export const MAX_CHAT_IMAGE_ATTACHMENTS = 4;

/**
 * 送信前のチャット添付画像。圧縮済みの blob と、プレビュー用の ObjectURL を保持する。
 * 実際のアップロードは送信時に行う（添付時にアップロードすると送信キャンセルで孤児オブジェクトが残るため）。
 */
export type PendingChatImageAttachment = {
  // クライアント側でプレビュー・削除を識別するための一時ID
  id: string;
  filename: string;
  mediaType: string;
  blob: Blob;
  // <img> プレビュー用の ObjectURL。不要になったら revoke する
  previewUrl: string;
};

/**
 * 圧縮済み blob を Firebase Storage にアップロードし、送信用の FileUIPart（参照パス）を返す。
 * url は data URL ではなく自アプリ内の参照パスにすることで、履歴・RTDB には参照だけが残る。
 */
export async function uploadChatImageAttachment(
  attachment: PendingChatImageAttachment,
  params: { groupId: GroupId; viewModelId: ViewModelId; userId: UserId; threadId: string }
): Promise<FileUIPart> {
  const imageId = uuidv4();
  const path = StoragePath.aiChatImagePath(params.groupId, params.viewModelId, params.userId, params.threadId, imageId);
  const storageRef = StorageRefBuilder.ref(path);

  await storageRef.put(attachment.blob, {
    contentType: attachment.mediaType,
    contentDisposition: `inline; filename*=utf-8''${encodeURIComponent(attachment.filename)}`,
    customMetadata: {
      originalFilename: attachment.filename,
    },
  });

  return {
    type: 'file',
    mediaType: attachment.mediaType,
    filename: attachment.filename,
    // 配信プロキシ・バックエンド検証が期待する先頭スラッシュ付きの参照パス
    url: `/${path}`,
  };
}
